export default __webpack_public_path__ + "static/media/icon_email_outline.1c2eb75c.svg";